import { render, staticRenderFns } from "./ArsipSurvey.vue?vue&type=template&id=4e7b2a1f&scoped=true&"
import script from "./ArsipSurvey.vue?vue&type=script&lang=js&"
export * from "./ArsipSurvey.vue?vue&type=script&lang=js&"
import style1 from "./ArsipSurvey.vue?vue&type=style&index=1&id=4e7b2a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b2a1f",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QSelect,QBtn,QInput,QMarkupTable,QPagination,QTable});
